import React, {useEffect} from "react";
import {CircularProgress, Grid} from "@material-ui/core";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from "./components/Table/Table";
import {connect} from "react-redux";
import useStyles from "../../pages/dashboard/styles";
import LastUpdate from "../../components/LastUpdate/LastUpdate";


function Dashboard(props) {

    const classes = useStyles();

    useEffect(() => {
        document.title = 'Übersicht'
        window.scrollTo(0, 0)
    }, [])

    const buildDataTable = (profile) => {
        const job_array = [];
        profile.companies.map((e) => {
            return e.jobs.map((j) => {
                job_array.push({
                    company: e.name,
                    interactions: j.application_type === 'email' ? j.likes : j.clickouts,
                    ...j,
                });
                // Because of linter
                return null
            });
        });
        return job_array;
    };
    return (
        <>
            {!Object.keys(props.profile).length || !props.profile.companies.length ?
                <CircularProgress color="secondary"/> :
                <>
                    <PageTitle title="Alle Stellenanzeigen"/>
                    <LastUpdate lastUpdateDate={props.profile.updated_at}/>
                    <Grid className={classes.mainContainer} container spacing={4}>
                        <Grid item xs={12}>
                            <Table data={buildDataTable(props.profile)}/>
                        </Grid>
                    </Grid>
                </>}
        </>
    );
}

const mapStateToProps = (
    {
        profile,
    },
    ) => {
        return {
            profile,
        };
    }
;


export default connect(mapStateToProps)(Dashboard);
